import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'components/Modal';
import Button from 'components/Button';
import history from 'helpers/history';
import classes from './ViewRequestReportModal.module.scss';
import { GridColumn, GridRow } from 'components/Layout/Grid';
import { getMomentDate } from 'util/date';

const ViewRequestReportModal = () => {
  const currentUser = useSelector(({ auth }) => auth?.user);
  const userTimeZone = currentUser?.timezone;
  const data = currentUser?.incident_reports_updates_requested?.[0];
  const [isShow, setIsShow] = useState(!!data);

  return (
    <Modal
      width="500px"
      newCloseIcon
      visible={isShow}
      onCancel={() => {}}
      hideCloseIcon
      closable={false}
      maskClosable={false}
      title="Incident Report"
      size="large"
      wrapClassName={classes.modalWrapper}
    >
      <div className={classes.modalContent}>
        <div className={classes.content}>
          <div>
            <span>
              The following Incident Report needs additional information before
              it can be completed. Please review and adjust the requested
              information as soon as possible.
            </span>
          </div>
          <GridRow col={3} gap={8} className={classes.infoBlock}>
            <GridColumn className={classes.info}>
              <span>Participant</span>
              <span>{data?.participant?.name}</span>
            </GridColumn>
            <GridColumn className={classes.info}>
              <span>Date</span>
              <span>
                {getMomentDate(
                  data?.incident_date,
                  userTimeZone,
                  'MMM D, YYYY'
                )}
              </span>
            </GridColumn>
            <GridColumn className={classes.info}>
              <span>Type</span>
              <span>{(data?.types || []).map(obj => obj.name).join(', ')}</span>
            </GridColumn>
            <GridColumn
              colSpan={3}
              className={classes.info}
              style={{ marginTop: '8px' }}
            >
              <span>Requested Changes</span>
              <span>{data?.req_additional_info}</span>
            </GridColumn>
          </GridRow>
          <div></div>
        </div>
        <div className={classes.footer}>
          <Button
            type="link"
            onClick={() => {
              setIsShow(false);
            }}
            size="large"
            fontSize="md"
            weight="md"
          >
            Remind Me Later
          </Button>
          <Button
            buttonType="primary"
            size="large"
            fontSize="md"
            weight="md"
            onClick={() => {
              setIsShow(false);
              history.push(`/employees/${currentUser.id}?tab=incident-reports`);
            }}
          >
            Edit Report
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewRequestReportModal;
